import React from 'react';
import { useNavigate } from 'react-router-dom';
import LandingNav from '../components/LandingNav';
import Footer from '../components/Footer';
import './Landing.css';

const Landing = () => {
    const navigate = useNavigate();

    const [currentSlide, setCurrentSlide] = React.useState(0);
    
    const templates = [
        { 
            id: 1, 
            name: 'Modern Minimal', 
            preview: '🖥️', 
            description: 'Temiz ve profesyonel',
            screenshot: '/site-ss/1.png'
        },
        { 
            id: 2, 
            name: 'Profesyonel', 
            preview: '💼', 
            description: 'İş dünyasına uygun',
            screenshot: '/site-ss/2.png'
        },
        { 
            id: 3, 
            name: 'Yaratıcı', 
            preview: '🎨', 
            description: 'Yaratıcı meslekler için',
            screenshot: '/site-ss/3.png'
        },
        { 
            id: 4, 
            name: 'Elegant', 
            preview: '✨', 
            description: 'Şık ve zarif tasarım',
            screenshot: '/site-ss/4.png'
        },
        { 
            id: 5, 
            name: 'Bold', 
            preview: '🔥', 
            description: 'Cesur ve etkileyici',
            screenshot: '/site-ss/5.png'
        },
    ];

    React.useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % templates.length);
        }, 7000);
        return () => clearInterval(interval);
    }, [templates.length]);

    return (
        <div className="landing">
            <LandingNav />
            <div className="landing-hero">
                <div className="hero-content">
                    <div className="hero-text">
                        <h1 className="landing-title">
                            Kişisel Web Sitenizi
                            <span className="highlight"> Dakikalar İçinde Oluşturun</span>
                        </h1>
                        <p className="landing-description">
                            Profesyonel özgeçmiş sitenizi kolayca oluşturun ve yönetin. 
                            Hiç kod bilgisi gerektirmeden, modern ve responsive bir kişisel sitenize sahip olun.
                        </p>
                        <div className="landing-actions">
                            <button 
                                className="landing-button primary"
                                onClick={() => navigate('/auth')}
                            >
                                Hemen Başla
                            </button>
                            <button 
                                className="landing-button secondary"
                                onClick={() => navigate('/dashboard')}
                            >
                                Giriş Yap
                            </button>
                        </div>
                    </div>
                    <div className="hero-visual">
                        <div className="template-slider">
                            <div className="slider-container">
                                {templates.map((template, index) => (
                                    <div
                                        key={template.id}
                                        className={`template-slide ${index === currentSlide ? 'active' : ''}`}
                                    >
                                        <div className="template-preview">
                                            <div className="template-screen">
                                                <div className="template-content">
                                                    <div className="template-screenshot">
                                                        {template.screenshot ? (
                                                            <img 
                                                                src={template.screenshot} 
                                                                alt={template.name}
                                                                loading="lazy"
                                                            />
                                                        ) : (
                                                            <div className="screenshot-placeholder">
                                                                <div className="screenshot-icon">{template.preview}</div>
                                                                <h3 className="template-name">{template.name}</h3>
                                                                <p className="template-desc">{template.description}</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="slider-indicators">
                                {templates.map((_, index) => (
                                    <button
                                        key={index}
                                        className={`indicator ${index === currentSlide ? 'active' : ''}`}
                                        onClick={() => setCurrentSlide(index)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="features" className="landing-features">
                <div className="feature-grid">
                    <div className="feature-card">
                        <div className="feature-icon">🚀</div>
                        <h3 className="feature-title">Hızlı Kurulum</h3>
                        <p className="feature-description">
                            Sadece birkaç dakika içinde profesyonel bir site oluşturun
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">🎨</div>
                        <h3 className="feature-title">Modern Tasarımlar</h3>
                        <p className="feature-description">
                            Hazır temalar ile şık ve profesyonel görünüm
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">📱</div>
                        <h3 className="feature-title">Mobil Uyumlu</h3>
                        <p className="feature-description">
                            Tüm cihazlarda mükemmel görünen responsive tasarım
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">🌐</div>
                        <h3 className="feature-title">Özel Domain</h3>
                        <p className="feature-description">
                            Kendi domain'inizi ekleyin ve profesyonel görünün
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">⚡</div>
                        <h3 className="feature-title">Hızlı ve Güvenli</h3>
                        <p className="feature-description">
                            Cloudflare altyapısı ile yüksek performans ve güvenlik
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">📝</div>
                        <h3 className="feature-title">Kolay Yönetim</h3>
                        <p className="feature-description">
                            Kullanıcı dostu panel ile içeriğinizi kolayca düzenleyin
                        </p>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Landing;

